<div class="owner-abonos">

  <!-- Hero banner (hidden) -->
  <!--
  <div class="abonos-hero">
    <div class="hero-content">
      <h2 class="hero-title">
        Tus mejores experiencias,
        <span class="hero-highlight">en un solo pase.</span>
      </h2>
      <p class="hero-subtitle">
        Ahorra en los eventos de {{ ownerName || 'este espacio' }} con acceso a múltiples sesiones en un único abono.
      </p>
      <div class="hero-search">
        <i class="fa-light fa-ticket-simple"></i>
        <input
          class="search-input"
          type="text"
          placeholder="¿Qué tipo de abono buscas?"
          [(ngModel)]="searchText"
        />
      </div>
    </div>
  </div>
  -->

  <!-- Loading -->
  <div *ngIf="!loaded" class="loading-container">
    <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}" containerClass="loading-box"></ng-lottie>
  </div>

  <!-- Empty state -->
  <div *ngIf="loaded && filteredPasses.length === 0" class="empty-state">
    <div class="empty-icon">
      <i class="fa-light fa-ticket fa-3x"></i>
    </div>
    <h3>No hay abonos disponibles</h3>
    <p>Este espacio no tiene abonos activos en este momento.</p>
  </div>

  <!-- Passes grid -->
  <div class="passes-container container" *ngIf="loaded && filteredPasses.length > 0">
    <div class="passes-grid">
      <div class="pass-card" *ngFor="let pass of filteredPasses" (click)="openPass(pass)" [class.coming-soon]="isComingSoon(pass) || getUnavailableMessage(pass)">

        <!-- Card image mosaic -->
        <div class="card-media" [class.no-images]="getEventImages(pass).length === 0">
          <ng-container *ngIf="getEventImages(pass) as imgs">
            <ng-container *ngIf="imgs.length === 0">
              <div class="media-placeholder">
                <i class="fa-light fa-ticket-simple"></i>
              </div>
            </ng-container>
            <div *ngIf="imgs.length === 1" class="mosaic mosaic-1">
              <img [src]="imgs[0]" fallimg alt="Evento" />
            </div>
            <div *ngIf="imgs.length === 2" class="mosaic mosaic-2">
              <img [src]="imgs[0]" fallimg alt="Evento" />
              <img [src]="imgs[1]" fallimg alt="Evento" />
            </div>
            <div *ngIf="imgs.length === 3" class="mosaic mosaic-3">
              <img [src]="imgs[0]" fallimg alt="Evento" class="main" />
              <div class="side">
                <img [src]="imgs[1]" fallimg alt="Evento" />
                <img [src]="imgs[2]" fallimg alt="Evento" />
              </div>
            </div>
            <div *ngIf="imgs.length >= 4" class="mosaic mosaic-4">
              <img [src]="imgs[0]" fallimg alt="Evento" />
              <img [src]="imgs[1]" fallimg alt="Evento" />
              <img [src]="imgs[2]" fallimg alt="Evento" />
              <div class="img-more">
                <img [src]="imgs[3]" fallimg alt="Evento" />
                <span *ngIf="getEventCount(pass) > 4" class="more-count">+{{ getEventCount(pass) - 4 }}</span>
              </div>
            </div>
          </ng-container>

          <!-- Badges overlay -->
          <div class="badges-overlay">
            <span class="badge badge-coming-soon" *ngIf="isComingSoon(pass)">
              <i class="fa-light fa-clock"></i> Próximamente
            </span>
            <span class="badge badge-unavailable" *ngIf="!isComingSoon(pass) && getUnavailableMessage(pass)">
              <i class="fa-light fa-ban"></i> No disponible
            </span>
            <ng-container *ngIf="!isComingSoon(pass) && !getUnavailableMessage(pass)">
              <span class="badge badge-sold" *ngIf="isMostSold(pass)">
                <i class="fa-solid fa-fire-flame-curved"></i> Más vendido
              </span>
              <span class="badge badge-discount" *ngIf="!isMostSold(pass)">
                {{ getDiscountLabel(pass) }}
              </span>
            </ng-container>
            <span class="badge badge-flexible" *ngIf="isFlexible(pass)">
              Flexible
            </span>
          </div>
        </div>

        <!-- Card body -->
        <div class="card-body">
          <h3 class="pass-name">{{ pass.public_name || pass.name }}</h3>

          <ul class="pass-features">
            <li *ngIf="getEventCount(pass) > 0">
              <i class="fa-light fa-calendar-check"></i>
              <span *ngIf="!isFlexible(pass)">Incluye {{ getEventCount(pass) }} evento{{ getEventCount(pass) !== 1 ? 's' : '' }}</span>
              <span *ngIf="isFlexible(pass)">Elige {{ pass.min_events }} de {{ getEventCount(pass) }} eventos</span>
            </li>
            <li>
              <i class="fa-light fa-tag"></i>
              <span>{{ getDiscountLabel(pass) }}</span>
            </li>
            <li *ngIf="!isComingSoon(pass) && getUnavailableMessage(pass) as unavailable">
              <i class="fa-light fa-circle-exclamation"></i>
              <span>{{ unavailable }}</span>
            </li>
            <li *ngIf="(pass.starts_at || pass.ends_at) && !getUnavailableMessage(pass)">
              <i class="fa-light fa-clock"></i>
              <span *ngIf="isComingSoon(pass)">
                Disponible desde {{ pass.starts_at | date:'dd/MM/yyyy' }}
              </span>
              <span *ngIf="!isComingSoon(pass) && pass.starts_at && pass.ends_at">
                Hasta {{ pass.ends_at | date:'dd/MM/yyyy' }}
              </span>
              <span *ngIf="!isComingSoon(pass) && !pass.starts_at && pass.ends_at">
                Disponible hasta {{ pass.ends_at | date:'dd/MM/yyyy' }}
              </span>
              <span *ngIf="!isComingSoon(pass) && pass.starts_at && !pass.ends_at">
                Desde {{ pass.starts_at | date:'dd/MM/yyyy' }}
              </span>
            </li>
          </ul>
        </div>

        <!-- Card footer -->
        <div class="card-footer">
          <button class="btn-comprar" [class.btn-coming-soon]="isComingSoon(pass) || getUnavailableMessage(pass)" [disabled]="isComingSoon(pass) || getUnavailableMessage(pass)" (click)="openPass(pass); $event.stopPropagation()">
            <ng-container *ngIf="isComingSoon(pass)"><i class="fa-light fa-clock"></i> Disponible pronto</ng-container>
            <ng-container *ngIf="!isComingSoon(pass) && getUnavailableMessage(pass)"><i class="fa-light fa-ban"></i> No disponible</ng-container>
            <ng-container *ngIf="!isComingSoon(pass) && !getUnavailableMessage(pass)">Comprar abono</ng-container>
          </button>
        </div>

      </div>
    </div>
  </div>

</div>
